export const MAX_VIDEO_DURATION_SEC = 140.09; // 2:20:09
